import { render, staticRenderFns } from "./checkoutWeightLoss.vue?vue&type=template&id=c756ee26"
import script from "./checkoutWeightLoss.vue?vue&type=script&lang=js"
export * from "./checkoutWeightLoss.vue?vue&type=script&lang=js"
import style0 from "./checkoutWeightLoss.vue?vue&type=style&index=0&id=c756ee26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports